<template>
    <div class="amenity-checkbox-container">
        <form-checkbox class="amenity-checkbox" type="checkbox" @change="onChange" v-model="value"></form-checkbox>
    </div>
</template>

<script>
import formCheckbox from '../../generic/form-checkbox/form-checkbox.vue';

export default {
    components: { formCheckbox },
    data() {
        return {
            value: null,
        };
    },
    mounted() {
        this.value = this.params.value;
    },
    methods: {
        onChange(value) {
            if (this.params.onChange) {
                this.params.onChange(this.params, value);
            }
        },
        refresh(params) {
            this.$nextTick(() => {
                this.value = params.value;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.amenity-checkbox-container {
    cursor: pointer;
    display: flex;
    justify-content: center;
    .amenity-checkbox {
        padding-left: 2rem !important;
        margin-bottom: 0 !important;
    }
    :deep(.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after) {
        cursor: pointer !important;
    }
}
</style>